export default __webpack_public_path__ + "static/bg-3-b7a68ef5a0a67481b3259df2dcb324ae.png";